import { render } from "./home-two-grid.vue?vue&type=template&id=7846e564&scoped=true"
import script from "./home-two-grid.vue?vue&type=script&lang=js"
export * from "./home-two-grid.vue?vue&type=script&lang=js"

import "./home-two-grid.vue?vue&type=style&index=0&id=7846e564&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7846e564"]])

export default __exports__